import {
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const Supervisors = () => {
  const context = useContext(CompetitionContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const { get } = useApi();
  const { error } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  // const [removeLoading, setRemoveLoading] = useState(false);
  const [checked, setChcked] = useState([]);

  useEffect(() => {
    const getData = async () => {
      await getSupervisors();
      await getCompetitionRegister();
    };
    getData();
  }, [id,search]);

  const getSupervisors = async () => {
    setLoading(true);
    await get(
      `/competition-register/${id}/supervisor`,
      (res) => {
        context.supervisors = res;
      },
      (err) => {
        error('دریافت اطلاعات شرکت کنندگان با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getCompetitionRegister = async () => {
    setLoading(true);
    await get(
      `/competition-register/${id}`,
      (res) => {
        context.competitionRegister = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title={`لیست سرپست های مسابقه ${context.competitionRegister?.competition?.title}`}
          showBackBtn={false}
          showCreateBtn={false}
          showFilterBtn={true}
          backPath={`/competition/competition-register?competition_id=${context.competitionRegister?.competition?.id}`}
        />
        <div className='row mt-2 mb-3'>
          <div className='col-12 col-md-4'>
            <div className='d-flex flex-row justify-content-start'>
              <button
                onClick={() => {
                  if (checked.length === 0) {
                    return error(
                      'برای چاپ آی دی کارت لطفا ابتدا سطر های مورد نظر را انتخاب کنید.',
                    );
                  }
                  return navigate(
                    `/id-card/competition/${context.competitionRegister?.competition?.id}`,
                    {
                      state: {
                        users: checked,
                        type: 'supervisor',
                        competition_register_id: id,
                        usersRegister: context?.users,
                        sid: 'سرپرست',
                      },
                      replace: true,
                    },
                  );
                }}
                className='btn bg-purple p-2 text-white f-13'
              >
                چاپ آی دی کارت
              </button>
            </div>
          </div>
        </div>
        <Datatable
          data={context?.supervisors?.data}
          editUrl='#'
          meta={context?.supervisors?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          disableAllActions={true}
          selectRows={true}
          setRowId={setChcked}
          rowId={checked}
          basePagePath={`/competition-register/${id}/supervisor`}
          columns={[
            'تصویر',
            'نام',
            'نام خانوادگی',
            'کد ملی',
            'شماره همراه',
            'تاریخ تولد',
          ]}
          rows={[
            { name: 'personnel_image', type: 'image' },
            { name: 'name', type: 'string' },
            { name: 'last_name', type: 'string' },
            { name: 'national_card_id', type: 'string' },
            { name: 'mobile', type: 'string' },
            { name: 'birthday', type: 'date' },
          ]}
        />
      </Master>
    </>
  );
};
export default Supervisors;
